import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    apiUrl: process.env.VUE_APP_API_URL,
    websocketUrl: process.env.VUE_APP_WEBSOCKET_URL,
    token: window.localStorage.getItem('jwt'),
    domains: null,
    showSidebar: false,
    workspaces: null,
    activeWorkspace: null,
    contentplans: null,
    activeContentplan: null,
    keywords: null,
    topics: null,
    articles: null,
    articlesTotalCount: 0,
    translatedArticles: null,
    availableLanguages: [],
    pages: null,
    score: null,
    article: null,
    articleUrls: null,
    articleExternalUrls: null,
    crawl: null,
    gsc: {
      byDate: null,
      byQuery: null,
      byPage: null,
      byPageTypeDate: null,
      byPageTypeSummary: null,
      pagination: {
        queryNextCursor: null,
        pageNextCursor: null
      },
      meta: {
        elapsedMs: 0,
        scRequestCount: 0,
        resultSizes: {
          DATE: 0,
          QUERY: 0,
          PAGE: 0,
          PAGE_TYPE: 0
        },
        paginationHops: {
          DATE: 0,
          QUERY: 0,
          PAGE: 0,
          PAGE_TYPE: 0
        },
        truncated: {
          byQuery: false,
          byPage: false,
          byPageType: false
        },
        partial: false,
        pageType: {
          language: null,
          filters: []
        }
      }
    },
    pageKeywords: null,
    benchmarks: null,
    internalLinks: null,
    integrations: [],
    progressTrackers: [],
    snackbar: {
      open: false,
      text: '',
      type: ''
    },
    websocket: {
      instance: null,
      connected: false,
      initializing: false,
      reconnectAttempts: 0,
      maxReconnectAttempts: 5,
      messages: []
    },
    workspaceUsers: [],
    autoblogSettings: {}
  },
  getters,
  mutations,
  actions
})
